import { Component, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BANDEAU_URL, BANNER } from 'src/app/shared/enums/bandeau-url.enum';
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { URL_PAGE } from 'src/app/shared/enums/url.pages.enum';
import { Title } from "@angular/platform-browser";
import { Titles } from "src/app/shared/enums/messages.enum";

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-bandeau-entete',
  templateUrl: './bandeau-entete.component.html',
  styleUrls: [ './bandeau-entete.component.scss', './bandeau-entete.component.mobile.scss' ],
  imports: [RouterLink],
  standalone: true
})

export class BandeauEnteteComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly titleService = inject(Title);
  public banner = 'Expédition';
  showBanner: boolean = true;

  ngOnInit(): void {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .pipe(
        untilDestroyed(this)
      )
      .subscribe({
      next: (event: any) => {
        const excluded: string[] = [
          URL_PAGE.HOME,
          URL_PAGE.BIENVENUE,
          URL_PAGE.AUTOLOGIN,
          BANDEAU_URL.RECHERCHE_EXP,
          BANDEAU_URL.RECHERCHE_CONTENANTS
        ];
        const excludedExactUrls: string[] = [
          `/${BANDEAU_URL.EXP_AUTO}`,
          `/${BANDEAU_URL.EXP_MANUELLE}`,
          `/${BANDEAU_URL.SORTIE_VOL}`
        ];
        const isExcluded = excluded.some(url => event?.url.includes(url));
        const isExactExcluded = excludedExactUrls.includes(event?.url);
        this.showBanner = !(isExcluded || isExactExcluded);
        switch (true) {
          case event.url.includes(BANDEAU_URL.EXP_AUTO):
            this.titleService.setTitle(Titles.EXPEDITION_AUTO);
            this.banner = BANNER.BANNER_EXP_AUTO;
            break;
          case event.url.includes(BANDEAU_URL.EXP_MANUELLE):
            this.titleService.setTitle(Titles.EXPEDITION_MANUELLE);
            this.banner = BANNER.BANNER_EXP_MANUELLE;
            break;
          case event.url.includes(BANDEAU_URL.SORTIE_VOL):
            this.titleService.setTitle(Titles.SORTIE_VOL);
            this.banner = BANNER.BANNER_SORTIE_VOL;
            break;
          case event.url.includes(BANDEAU_URL.RECHERCHE_EXP):
            this.titleService.setTitle(Titles.RECHERCHE_EXP);
            break;
          case event.url.includes(BANDEAU_URL.HOME):
            this.titleService.setTitle(Titles.HOME);
            break;
          case event.url.includes(BANDEAU_URL.RECHERCHE_CONTENANTS):
            this.titleService.setTitle(Titles.RECHERCHE_CONTENANTS);
            this.banner = BANNER.RECHERCHE_CONTENANTS;
            break;
          default:
            this.titleService.setTitle(Titles.DEFAULT_TITLE);
            this.banner = BANNER.BANNER_DEFAULT_EXP;
            break;
        }
      }
    });

  }

}

